import { company } from '../data/site'

const SUBJECT = 'Quote request — CoPro Services'

const BODY = [
  'Hello CoPro Services,',
  '',
  "I'd like a quote for a commercial or industrial project.",
  '',
  'Company / property:',
  'Property type (office, warehouse, retail, multifamily, industrial):',
  'Service needed (painting, cleaning, property services):',
  'Location:',
  'Timeline:',
  'Project details:',
  '',
  'Best number to reach me:',
].join('\n')

/** Opens the visitor's email app with a pre-filled quote request. */
export const directQuoteMailto = `mailto:${company.email}?subject=${encodeURIComponent(
  SUBJECT,
)}&body=${encodeURIComponent(BODY)}`
